import { FC } from 'react';

import { Checkbox, CheckboxProps, Loader } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

interface CustomCheckboxProps extends CheckboxProps {
  loading?: boolean;
  customOnClick?: () => void;
}

const CustomCheckbox: FC<CustomCheckboxProps> = ({
  loading,
  disabled,
  readOnly,
  checked,
  onChange,
  customOnClick,
  ...rest
}) => {
  const CheckboxIcon: CheckboxProps['icon'] = ({ className }) =>
    loading ? (
      <Loader className={className} size={12} />
    ) : (
      <IconCheck className={className} stroke={1.5} />
    );

  if (readOnly) {
    return checked ? <IconCheck size={16} stroke={1.5} /> : <IconX size={16} stroke={1.5} />;
  }

  return (
    <Checkbox
      {...rest}
      checked={checked}
      icon={CheckboxIcon}
      disabled={disabled || loading}
      onChange={(e) => {
        onChange?.(e);
        customOnClick?.();
      }}
    />
  );
};

export default CustomCheckbox;
